module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback3-a5d4f41717f5c0307a5fd6d456e86689.jpg";